import { LocalizeBySchemaBaseValueConverter } from 'General/Resources/ValueConverters/LocalizeBySchemaBase';

export class LocalizeBySchemaValueConverter extends LocalizeBySchemaBaseValueConverter {}